<template>
	<div id="locQuery_s1">
		<v-container :left="true" :height="'1.4rem'" :title="title" @esc="esc">
			<template slot="content">
				<v-input
					:config="config"
					:models="models"
					:rules="rules"
					@complete="complete"
					@esc="esc"
					ref="models"
				></v-input>
				<van-row>
					<van-col span="8" style="padding:1em"
						>品样数: {{ tableData.quantity }}</van-col
					>
					<van-col span="8" style="padding:1em"
						>总数量: {{ tableData.totalQuantity }}</van-col
					>
					<van-col span="8" style="padding:1em"
						>总箱数: {{ tableData.totalIds }}</van-col
					>
				</van-row>
				<el-table
					:data="tableData.list"
					border
					stripe
					:header-cell-style="{ color: '#fff', background: '#02a7f0' }"
					:max-height="450"
				>
					<el-table-column prop="sku" label="SKU" :width="160" align="center">
					</el-table-column>
					<el-table-column
						prop="storeWarehouseDesc"
						:label="$t('module.storeWarehouse')"
						:width="100"
						align="center"
					>
					</el-table-column>
					<el-table-column
						prop="qty"
						:label="$t('module.qtyreceived')"
						:width="60"
						align="center"
					>
					</el-table-column>
					<el-table-column prop="id" label="LPN" :width="100" align="center">
					</el-table-column>
					<el-table-column
						prop="itemNumber"
						:label="$t('module.style')"
						:width="100"
						align="center"
					>
					</el-table-column>
					<el-table-column
						prop="colour"
						:label="$t('module.color')"
						:width="100"
						align="center"
					>
					</el-table-column>
					<el-table-column
						prop="size"
						:label="$t('module.skusize')"
						:width="100"
						align="center"
					>
					</el-table-column>
					<template v-for="col in appendColumns">
						<el-table-column
							:key="col.prop"
							:prop="col.prop"
							:label="col.label"
							:width="100"
							align="center"
						>
						</el-table-column>
					</template>
				</el-table>
			</template>
		</v-container>
	</div>
</template>

<script>
import container from 'commons/Container';
import input from 'commons/Input';
import foot from '../../../commons/Footer';
import baseMixin from '@/mixins/baseMixin';

export default {
	name: 'locQuery_s1',
	mixins: [baseMixin],
	data() {
		return {
			loading: false,
			title: this.$t('module.locQuerytitle'),
			config: [{ label: this.$t('module.loc'), prop: 'loc', focus: true }],
			models: {
				loc: '',
			},
			rules: {
				loc: [
					{
						required: true,
						message: this.$ScanPlease('module.loc'),
						trigger: ' ',
					},
				],
			},
			flag: false,
			tableData: {
				totalQuantity: 0,
				quantity: 0,
				totalIds: 0,
				list: [],
			},
			appendColumns: [],
		};
	},
	computed: {
		btnConfig() {
			return [];
		},
	},
	methods: {
		esc() {
			this.$router.go(-1);
		},
		async complete(model, ref, callback) {
			this.appendColumns = [];
			this.tableData = {
				totalQuantity: 0,
				quantity: 0,
				totalIds: 0,
				list: [],
			};
			this.loading = true;
			try {
				let data = {
					loc: model.loc,
				};
				let res = await this.http.post(
					`/inventoryQuery/queryBySkuOrIdOrLocOrStyle`,
					data
				);
				if (res.status == 200 && res.data.returnCode == 200) {
					this.tableData = res.data.bean;
					if (this.tableData.quantity == 0) {
						this.$message({
							message: '查询库存为空',
							type: 'error',
						});
						this.music();
					} else {
						this.music2();
						this.tableData.list = this.tableData.list.map((item) => {
							item.lottable01 = item.storeWarehouse;
							return item;
						});
						const data = this.tableData.list[0];
						const rules = data.rflottabledisplayrules
							.split('+')
							.map((item) => item.toLowerCase());
						rules.forEach((ele) => {
              if(ele == 'lot'){
                this.appendColumns.push({
                  label: '批次',
                  prop: 'lot',
                });
              }else{
                this.appendColumns.push({
                  label: data[ele.replace('lottable', 'rflabel')],
                  prop: ele,
                });
              }
						});
					}
					callback('loc');
				} else {
					this.music();
					this.$message.error(res.data.returnMgr);
					callback('loc');
				}
			} catch (e) {
				this.music();
				this.$message.error(e);
				callback('loc');
			} finally {
				this.loading = false;
			}
		},
	},
	mounted() {},
	components: {
		'v-container': container,
		'v-input': input,
		'v-foot': foot,
	},
};
</script>

<style scoped></style>
